import {MolecularGraph} from "../../graph/MolecularGraph"
import {Feature, Features} from "../../feature";
import {extractorUtil} from "../../util/extractorUtil";

export const ringExtractor = {
    extract: (graph: MolecularGraph) => {
        const rings = extractorUtil.findAllRingAtoms(graph);

        return rings.map(ring => {
            let name = `${Features.ring}.${ring.length}`

            if (ring.length === 6 && ring.every(a => a.symbol === "C")) {
                const network = extractorUtil.findRingNetwork(ring, graph);
                const bondOrderSum = network.reduce((acc, b) => acc + b.order, 0);
                if (bondOrderSum === 9) {
                    name = Features.benzene;
                }
            }
            const r = Array.from(new Set(ring.map(atom => extractorUtil.getFilteredNonHConnectedAtoms(atom, graph, ring)).flat()));

            // A ring is conjoined if it shares a vertex with another ring. When rings are conjoined, their connections
            // to the other ring are the conjoined atoms.
            const conjoinedRings = rings.filter(r => r !== ring && r.some(a => ring.includes(a)))
            const rMinusConjoined = r.filter(a => conjoinedRings.every(ca => !ca.includes(a)));
            const conjoinedR = conjoinedRings.map(joinedRing => joinedRing.filter(joinedAtom => ring.includes(joinedAtom)));
            const newR = Array.from(new Set([...rMinusConjoined, ...conjoinedR.flat()]));
            return {name, atoms: ring, connections: newR} as Feature
        })
    }
}
